import { useOnlineStatus } from '../hooks/useOnlineStatus';
import { WifiOff, RefreshCw, Check } from 'lucide-react';

export const OfflineIndicator = () => {
  const { isOnline, pendingSyncs, justSynced } = useOnlineStatus();

  // Show synced toast briefly
  if (justSynced) {
    return (
      <div
        className="fixed top-0 left-0 right-0 z-[100] bg-green-600 text-white text-center py-1.5 text-xs font-medium flex items-center justify-center gap-1.5 animate-in slide-in-from-top"
        data-testid="sync-complete-banner"
      >
        <Check className="h-3.5 w-3.5" />
        Synced! All pending changes saved.
      </div>
    );
  }

  // Show offline banner
  if (!isOnline) {
    return (
      <div
        className="fixed top-0 left-0 right-0 z-[100] bg-slate-800 text-white text-center py-1.5 text-xs font-medium flex items-center justify-center gap-1.5"
        data-testid="offline-banner"
      >
        <WifiOff className="h-3.5 w-3.5" />
        You're offline
        {pendingSyncs > 0 && (
          <span className="ml-1 px-1.5 py-0.5 bg-amber-500 rounded-full text-[10px] font-bold">
            {pendingSyncs} pending
          </span>
        )}
      </div>
    );
  }

  // Show pending syncs while online (items queued but not yet sent)
  if (pendingSyncs > 0) {
    return (
      <div
        className="fixed top-0 left-0 right-0 z-[100] bg-amber-500 text-white text-center py-1.5 text-xs font-medium flex items-center justify-center gap-1.5"
        data-testid="pending-sync-banner"
      >
        <RefreshCw className="h-3.5 w-3.5 animate-spin" />
        Syncing {pendingSyncs} pending change{pendingSyncs !== 1 ? 's' : ''}...
      </div>
    );
  }

  return null;
};
